/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderDetail {
  compositionId?: number;
  dateCreated?: Date;
  dateSyncERP?: Date;
  dateUpdatedMillennium?: Date;
  editionId?: number;
  finalDeliveryDate?: Date;
  items?: number;
  pedidoV?: string;
  personEmail?: string;
  personId?: number;
  personName?: string;
  referenceName?: string;
  shippingOrderId?: number;
  shippingOrderStatus?: number;
  shippingOrderStatusName?: string;
  shippingOrderTypeId?: number;
  shippingOrderTypeName?: string;
  statusMillennium?: string;
  theme?: string;
}
